import { jsx as _jsx } from "react/jsx-runtime";
import { NodeTypeModalForm } from '../EntityModalForms/NodeTypeModalForm';
function CreateNodeTypeModal({ isOpen, onClose, onCreate, isLoading }) {
    return (_jsx(NodeTypeModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onCreate, isLoading: isLoading, mode: "create", nodeType: null, title: "Create Node Type", submitIdleLabel: "Create", submitBusyLabel: "Creating..." }));
}
export default CreateNodeTypeModal;
